export default __webpack_public_path__ + "static/media/up_to_6.5490fc16.svg";